import React from "react";

export default function Divider(props) {
  const { size } = props;

  if (size === "small"){
    return <div className="flex my-1 sm:my-3" />;
  }
  return <div className="flex my-6" />;
}